import { render } from "./myserverIndex.vue?vue&type=template&id=467558b7"
import script from "./myserverIndex.vue?vue&type=script&lang=js"
export * from "./myserverIndex.vue?vue&type=script&lang=js"

import "./myserverIndex.vue?vue&type=style&index=0&id=467558b7&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__